import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NestedLink, { NestedLinkProps } from './NestedLink'
import TickSvg from '../other/svg/TickSvg'

interface Props {
  icon: React.ReactNode
  label: string
  path?: string | null
  active: boolean
  disabled?: boolean
  nestedLinks?: NestedLinkProps[]
  isOpen?: boolean
  setIsOpen?: (isOpen: boolean) => void
}

const NewMenuItem = ({
  icon,
  label,
  path = null,
  active,
  nestedLinks = [],
  disabled = false,
  isOpen = false,
  setIsOpen = () => {
    // Default no-op function
  }
}: Props): JSX.Element => {
  const { t } = useTranslation()
  return (
    <div className="w-full" style={{ opacity: disabled ? 0.5 : 1 }}>
      <Link
        to={path ?? '#'}
        style={{ backgroundColor: active ? '#3582CE' : '#fafafa' }}
        className="self-stretch px-1.5 py-2 bg-blue-500 rounded-md inline-flex justify-start items-center gap-2 overflow-hidden w-full cursor-pointer"
        onClick={() => {
          if (!disabled) {
            setIsOpen(!isOpen)
          }
        }}>
        <div className="w-6 h-6 flex justify-center items-center">
          <div style={{ color: active ? 'white' : '#52525B' }} className="w-3.5 h-3.5 relative color-white">
            {icon}
          </div>
        </div>
        <div
          style={{ color: active ? 'white' : '#52525B', fontWeight: active ? 'bold' : 'normal' }}
          className="flex-1 justify-start text-xs font-bold font-Montserrat leading-tight">
          {label}
        </div>

        {nestedLinks.length > 0 && !disabled && (
          <div>
            <TickSvg style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
          </div>
        )}

        {disabled && (
          <div className="h-4 px-0.5 bg-backgrounds-bg-field-component rounded outline outline-1 outline-borders-border-strong inline-flex flex-col justify-center items-center overflow-hidden">
            <div className="text-center justify-start text-foregrounds-fg-subtle text-[8px] font-medium font-opensans leading-tight">
              {t('soon')}
            </div>
          </div>
        )}
      </Link>
      <div
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{
          height: isOpen ? `${nestedLinks.length * 45}px` : '0px',
          opacity: isOpen ? 1 : 0
        }}>
        <div className="self-stretch pl-4 inline-flex justify-end items-center gap-3 w-full">
          <div className="w-px self-stretch bg-borders-border-base" />
          <div className="flex-1 pb-3 inline-flex flex-col justify-start items-start gap-1 w-full">
            {nestedLinks.map((link) => (
              <NestedLink key={link.label} active={link.active} icon={link.icon} label={link.label} path={link.path} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewMenuItem
